import React from 'react';

import IntroductionAddIcon from '@atlaskit/icon-lab/core/text-introduction-add';

export const InsertAtTopIcon = (): React.JSX.Element => (
	<IntroductionAddIcon label="" spacing="spacious" />
);
